import { createBaseThemeVariation } from './base';
export const GrandirUKTheme = createBaseThemeVariation({
    name: 'grandiruk',
    brandColor: 'hsla(98, 16%, 30%, 1)',
    primaryColors: {
        p50: 'hsla(98, 16%, 98%, 1)',
        p75: 'hsla(98, 16%, 97%, 1)',
        p100: 'hsla(98, 16%, 96%, 1)',
        p200: 'hsla(98, 16%, 90%, 1)',
        p300: 'hsla(98, 16%, 70%, 1)',
        p400: 'hsla(98, 16%, 30%, 1)',
        p500: 'hsla(98, 16%, 15%, 1)',
    },
});
